export class BestandsbuchArtikelTier {
    bat_id: number;
    bestandsbuch_artikel_id: number;
    ohrmarke_notnull: string;
    tier_id: number;
    editiert: Date;
}
